export const MetaConfig = {
  Home: {
    title: 'meta_config_Data5',
    description: ' ',
    robots: 'meta_config_Data1',
  },
  Contact: {
    title: 'meta_config_Data6',
    description: ' ',
    robots: 'meta_config_Data1',
  },
  Register: {
    title: 'meta_config_Data7',
    description: ' ',
    robots: 'meta_config_Data1',
  },
  Login: {
    title: 'meta_config_Data8',
    description: ' ',
    robots: 'meta_config_Data1',
  },
  TermsOfUse: {
    title: 'meta_config_Data9',
    description: ' ',
    robots: 'meta_config_Data2',
  },
  Cookies: {
    title: 'meta_config_Data10',
    description: ' ',
    robots: 'meta_config_Data2',
  },
  Privacy: {
    title: 'meta_config_Data11',
    description: ' ',
    robots: 'meta_config_Data2',
  },
  Hiring: {
    title: 'meta_config_Data12',
    description: ' ',
    robots: 'meta_config_Data2',
  },
};
